import { render, staticRenderFns } from "./HistoryArchive.vue?vue&type=template&id=1232260a"
import script from "./HistoryArchive.vue?vue&type=script&setup=true&lang=ts"
export * from "./HistoryArchive.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports